import { useEffect, useState } from "react";
import { Button, Text, Box } from "@chakra-ui/react";
import { ethers } from "ethers";

const { ethereum } = window;

export default function ContractLayout({ contractInfo, contract, setContract, address, setAddress, children }) {
    const [chainId, setChainId] = useState(null);
    const [metaMaskInstalled, setMetaMaskInstalled] = useState(false);
    const [isConnected, setIsConnected] = useState(false);
    const [isSameChainId, setIsSameChainId] = useState(false);

    useEffect(() => {
        if (ethereum) {
            setMetaMaskInstalled(true);
            ethereum.on("chainChanged", chainIdChanged);
            ethereum.on("accountsChanged", accountsChanged);
            setAddress(ethereum.selectedAddress); // 初回はnull
            setChainId(ethereum.networkVersion); // 初回はnull
        } else {
            setMetaMaskInstalled(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => setIsConnected(address ? true : false), [address]);
    // eslint-disable-next-line eqeqeq
    useEffect(() => setIsSameChainId(chainId == contractInfo.chainId), [contractInfo.chainId, chainId]);

    useEffect(() => {
        console.log("address changed", address, chainId);
        // eslint-disable-next-line eqeqeq
        if (address && chainId == contractInfo.chainId) {
            const provider = new ethers.providers.Web3Provider(ethereum);
            const signer = provider.getSigner();
            const _contract = new ethers.Contract(contractInfo.address, contractInfo.abi, signer);
            setContract(_contract);
        } else {
            setContract(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [address, chainId]);

    function chainIdChanged(_chainId) {
        // window.location.reload();
        console.log("ChainID Changed");
        setChainId(_chainId);
    }

    function accountsChanged(_accounts) {
        console.log("Accounts Changed");
        setAddress(_accounts[0]);
    }

    async function connect() {
        const accounts = await ethereum.request({
            method: "eth_requestAccounts", // HINT: これでaccountsChangedが呼ばれるわけではない
        });
        console.log("connect", accounts[0]);
        setAddress(accounts[0]); //ethereum.selectedAddress);
        setChainId(ethereum.networkVersion);
    }

    return (
        <Box textAlign="center">
            {!metaMaskInstalled ? ( // MetaMaskがインストールされているか?
                <Box bg="pink.100" fontSize="md" borderRadius="md" p="2" mx="10">
                    <Text fontWeight="bold">Please install MetaMask.</Text>
                </Box>
            ) : !isConnected ? ( // connectしているか?
                <Box>
                    <Button colorScheme="blue" onClick={connect}>
                        Connect Wallet
                    </Button>
                </Box>
            ) : !isSameChainId ? ( // chainIdが一致しているか
                <Box bg="pink.100" fontSize="md" borderRadius="md" p="2" mx="10">
                    <Text fontWeight="bold">Please change network to {contractInfo.networkName}.</Text>
                </Box>
            ) : (
                <>{children}</>
            )}
        </Box>
    );
}
